import React from 'react';
import Hero from '../../components/pages/WealthAndSavings/Hero/Hero';
import Approach from '../../components/pages/WealthAndSavings/Approach/Approach';
import Products from '../../components/pages/WealthAndSavings/Products/Products';
import Security from '../../components/pages/WealthAndSavings/Security/Security';
import HowToGetStarted from '../../components/pages/WealthAndSavings/HowToGetStarted/HowToGetStarted';
import BuildYourHeritage from '../../components/pages/WealthAndSavings/BuildYourHeritage/BuildYourHeritage';

const WealthAndSavings = () => {
  return (
    <div>
      <Hero />
      <Approach />
      <Products />
      <Security />
      <HowToGetStarted />
      <BuildYourHeritage />
    </div>
  );
};

export default WealthAndSavings;
